import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import { makeStyles, Grid, Typography, Hidden, Button } from '@material-ui/core';
import { PageTitle } from '../../components/PageTitle';
import { useUser } from '../../utilities/useUser';
import { routes } from '../../routes';
import { AuthLayout } from './AuthLayout';

const useStyles = makeStyles((theme) => ({
    textButton: {
        paddingLeft: '0px',
        paddingRight: '0px',
        marginTop: '50px',
        marginBottom: '50px'
    },
    buttonContainer: {
        padding: '30px 0px 70px 0px'
    },
    link: {
        textDecoration: 'none'
    },
}));

export function ForgotPasswordSuccess(){
    const userContext = useUser();
    const user = userContext.onlineUser;
    const classes = useStyles();

    if (user) {
        return <Redirect to={routes.app.libraryHomePage} />;
    }

    return (
        <AuthLayout>
            <PageTitle title="Sermon Maker - Forgot Password" />
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Typography variant="h5" style={{fontSize: "1.7rem", fontWeight: 500}}>Reset Password Link Sent</Typography>
                <Typography variant="subtitle1">Check your email for a link to reset your password.</Typography>
            </Grid>   
            <Hidden smDown>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" className={classes.buttonContainer}>
                    <Link to="/" className={classes.link}>
                        <Button variant="text" size="medium" color="primary" type="button" className={classes.textButton}>Sign In</Button>
                    </Link>
                </Grid>
            </Hidden>
            <Hidden mdUp>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Link to="/" className={classes.link}>
                        <Button variant="text" size="small" color="primary" type="button" className={classes.textButton}>Sign In</Button>
                    </Link>
                </Grid>
            </Hidden>
        </AuthLayout>
    );
}